import gql from 'graphql-tag';

export default gql`
  query UserTasks {
    me {
      formAnswers {
        xuid
        status
        recipient
        createdBy
        createdAt
        updatedAt

        form {
          xuid
          name
        }
      }

      xformAnswers(state: "contact") {
        xuid
        formName
        createdBy
        createdAt
        flowState
      }
    }
  }
`;
